





























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Row from '@/components/atoms/Grid/Row.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import {
  EConnectTransactionStatus,
  FormWebhookFakeFidel,
  TransactionTableListAdmin
} from '@/models/transaction';
import eventBus from '@/utils/eventBus';

interface IBusiness {
  id: string;
  label?: string;
  name: string;
  city: string;
  state: string;
}

interface ICustomer {
  id: string;
  mail: string;
  name: string;
  lastname: string;
  label?: string;
}

@Component({
  components: {
    ContentContainer,
    Row,
    SelectorAndList,
    TextInput,
    FilledButton,
    CustomSelect,
    TextField
  }
})
export default class WebhookFakeFidel extends Vue {
  @Prop({ required: false }) data!: TransactionTableListAdmin;
  adminService = new AdminService();
  businesses = [] as any;
  customers = [] as any;
  amountValue: string = '';

  businessesOptions: IBusiness[] = [];
  customersOptions: ICustomer[] = [];
  eventsTypeAvailable: any = [];
  dataForm: FormWebhookFakeFidel = this.newDataForm();
  isLoading: boolean = false;

  created() {
    this.initSelectEventTypesAvailable();
    this.dataForm = this.newDataForm();
    this._setBusinessDefault();
    this._setCustomerDefault();
  }

  async searchBusinesses(search: string) {
    try {
      const {
        data: { items }
      } = await this.adminService.searchBusinesses(search, true);

      this.businessesOptions = items.map(business => {
        return {
          label: `${business.name} (${getBusinessLocationInfo(business)})`,
          ...business
        };
      });
    } catch (e) {
      this.businessesOptions = [];
    }
  }

  async searchCustomers(search: string) {
    try {
      const {
        data: { items }
      } = await this.adminService.searchCustomers(search);

      this.customersOptions = items.map(({ customer }) => {
        return {
          label: `${customer.mail} (${customer.name} ${customer.lastname}) `,
          ...customer
        };
      });
    } catch (e) {
      this.customersOptions = [];
    }
  }

  async sendWebhookFakeFidel() {
    try {
      if (!this.validateFields()) {
        return;
      }

      this.isLoading = true;

      const { status } = await this.adminService.sendWebhookFakeFidel(
        this.dataForm
      );

      if (status === 201) {
        this.$notification(
          'Event created with success. Please wait for the webhook be processed... '
        );

        this.closeModal();
        this.dispatchEventWebhookCreated();
      }
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$notification(treatError(e));
    }
  }

  private _setBusinessDefault() {
    this.businesses = this.data
      ? [{ label: this.data.businessName, id: this.data.rawData.businessId }]
      : [];
  }

  private _setCustomerDefault() {
    this.customers = this.data
      ? [{ label: this.data.customerName, id: this.data.rawData.customer.mail }]
      : [];
  }
  newDataForm(): FormWebhookFakeFidel {
    this.amountValue = this.data ? this.data.amount.replace('$', '') : '0';

    const rawData = this.data ? this.data.rawData : null;
    return {
      businessId: rawData ? rawData.businessId : '',
      emailCustomer: rawData ? rawData.customer.mail : '',
      eventType: this._initEventTypeFilter(),
      amount: parseFloat(this.amountValue),
      externalTransactionId: rawData ? rawData.externalTransactionId : null
    };
  }

  private _initEventTypeFilter(): string {
    if (!this.data) {
      return 'transaction.auth';
    }

    const status =
      this.data.status === EConnectTransactionStatus.AUTHORIZED
        ? 'transaction.clearing'
        : 'transaction.auth';

    return status;
  }

  selectEventType(selected: CustomSelectOption[]) {
    this.dataForm.eventType = selected[0].uuid;
  }

  setAmount(value: string) {
    try {
      this.dataForm.amount = parseFloat(value);
    } catch (err) {
      this.dataForm.amount = 0;
    }
  }

  validateFields() {
    const hasBusiness = !!this.dataForm.businessId;
    const hasCustomerEmail = this.dataForm.emailCustomer !== '';

    const fieldsValidate = hasBusiness && hasCustomerEmail;

    if (!fieldsValidate) {
      this.$notification('Please, fill in all fields!! ', 'error');
    }

    return fieldsValidate;
  }

  private _getOptionsEventType(): CustomSelectOption[] {
    if (!this.data) {
      return [
        new CustomSelectOption('transaction.auth', `Auth`, true),
        new CustomSelectOption('transaction.clearing', `Clear`)
      ];
    }

    const opt = [];

    if (this.data.status === EConnectTransactionStatus.AUTHORIZED) {
      opt.push(new CustomSelectOption('transaction.clearing', `Clear`));
    }

    if (this.data.status === EConnectTransactionStatus.CLEARED) {
      opt.push(new CustomSelectOption('transaction.refund', `Refund`));
    }

    return opt;
  }
  initSelectEventTypesAvailable() {
    const options = this._getOptionsEventType();

    const actionGroup = new CustomSelectGroup(options);

    this.eventsTypeAvailable = new CustomSelectModel(
      [actionGroup],
      `Event Type`,
      false,
      true,
      false,
      true
    );
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: false,
      component: 'webhookFakeFidel'
    });
  }

  @Emit('webhookCreated')
  dispatchEventWebhookCreated() {
    return true;
  }
}
